
import { Route } from 'react-router-dom';
import Login from '../pages/auth/Login';
import SignUp from '../pages/auth/SignUp';
import AuthCallback from '../pages/auth/AuthCallback';
import EmailCallback from '../pages/auth/EmailCallback';
import ResetPassword from '../pages/auth/ResetPassword';
import Welcome from '../pages/Welcome';


export const PublicRoutes = [
  // Keep auth routes directly accessible without PublicRoute wrapper
  <Route key="auth-login" path="/auth/login" element={<Login />} />,
  <Route key="auth-signup" path="/auth/signup" element={<SignUp />} />,
  <Route key="auth-callback" path="/auth/callback" element={<AuthCallback />} />,
  <Route key="auth-email-callback" path="/auth/email-callback" element={<EmailCallback />} />,
  <Route key="auth-reset-password" path="/auth/reset-password" element={<ResetPassword />} />,
  // Welcome route for native app users
  <Route key="welcome" path="/welcome" element={<Welcome />} />,

];
